import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=008bb2de&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"
import style0 from "./FormSelect.vue?vue&type=style&index=0&id=008bb2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008bb2de",
  null
  
)

export default component.exports